import axios from "axios";
import { Img } from "components";
import { Suspense, useContext, useEffect, useState } from "react";
import { AppContext, useGlobalState } from "state";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ResetAndSubmit from "components/ResetAndSubmit";
import Input from "components/Input";
import { showGlobalModal } from "components/GlobalModal";
import SlotDigit from "pages/Onboarding/component/SlotDigit";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Marquee from "react-fast-marquee";
import Lottie from "lottie-react";
import HrAnimation from "assets/images/24hrAnimation.json";
import SateliteAnimation from "assets/images/SateliteAnimation.json";
import { API_CONSTANT_ONBOARDING } from "utils";

const LIST = [
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        Attendance <br /> Updates
      </p>
    ),
    image: (
      <Img
        className="h-[6vh]"
        src={"/images/Onboarding/AttendanceUpdates.svg"}
      />
    ),
  },
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        School <br /> Fee
      </p>
    ),
    image: <Img className="h-[6vh]" src={"/images/Onboarding/SchoolFee.svg"} />,
  },
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        Exam <br /> Updates
      </p>
    ),
    image: (
      <Img className="h-[6vh]" src={"/images/Onboarding/ExamUpdates.svg"} />
    ),
  },
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        Exam <br /> Results
      </p>
    ),
    image: (
      <Img className="h-[6vh]" src={"/images/Onboarding/ExamResults.svg"} />
    ),
  },
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        PTM <br /> Announcements
      </p>
    ),
    image: (
      <Img
        className="h-[6vh]"
        src={"/images/Onboarding/PTMAnnouncements.svg"}
      />
    ),
  },
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        Student <br /> Alerts
      </p>
    ),
    image: (
      <Img className="h-[6vh]" src={"/images/Onboarding/StudentsAlrets.svg"} />
    ),
  },
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        Birthday <br /> Wishes
      </p>
    ),
    image: (
      <Img className="h-[6vh]" src={"/images/Onboarding/BirthdayWise.svg"} />
    ),
  },
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        Festival <br /> Wishes
      </p>
    ),
    image: (
      <Img className="h-[6vh]" src={"/images/Onboarding/FestivalWise.svg"} />
    ),
  },
  {
    title: (
      <p className="text-[2vh] font-manropeB text-left">
        Preferred <br /> Languages
      </p>
    ),
    image: (
      <Img
        className="h-[6vh]"
        src={"/images/Onboarding/PreferredLanguage.svg"}
      />
    ),
  },
];

const DEFAULT_DATA = {
  LANGUAGE: "",
  ADMISSION_COUNSELLOR_MOBILE: "",
  COUNTRY_CODE: "+91",
};

const loadingMessages = [
  "Dialing into the system...",
  "Searching for the perfect IVR number... ",
  "Bringing your school’s voice to life...",
  "Hang tight, setting things up...",
];

const AutoConnectHub = ({ handleNavigate, resetFormData }) => {
  const [state, setState] = useState<any>({
    DID_NUMBER: {},
    LOADER: false,
  });
  const [loader, setLoader] = useState(false);
  const { globalData } = useContext(AppContext);
  const { instData } = useGlobalState();
  const [showZero, setShowZero] = useState(false);
  const [finalNumber, setFinalNumber] = useState<any>();
  const [handleError, setHandleError] = useState<any>();

  useEffect(() => {
    if (state?.DID_NUMBER?.DID_NUMBER) return;

    const interval = setInterval(() => {
      setShowZero(true);
      const timeout = setTimeout(() => {
        setShowZero(false);
      }, 1000);
      return () => clearTimeout(timeout);
    }, 10000);

    return () => clearInterval(interval);
  }, [state?.DID_NUMBER?.DID_NUMBER]);

  useEffect(() => {
    if (state?.DID_NUMBER?.DID_NUMBER) {
      setShowZero((showZero) => false);
      setTimeout(() => {
        setFinalNumber((finalNumber) => state?.DID_NUMBER?.DID_NUMBER);
      }, 6000);
    }
  }, [state?.DID_NUMBER?.DID_NUMBER]);

  const loadInitialData = () => {
    try {
      return (
        JSON.parse(sessionStorage.getItem("autoConnectHub")) || DEFAULT_DATA
      );
    } catch (err) {
      return DEFAULT_DATA;
    }
  };

  const areBIDAndInsIdPresent = () => {
    return instData?.BRANCH_ID && instData?.INSTITUTE_ID;
  };

  const fetchData = async () => {
    try {
      setHandleError((handleError) => null);
      const response = await axios.get(
        `${API_CONSTANT_ONBOARDING}/master/didNumber/list?query=DID_STATUS=available`
      );
      setState((state) => ({
        ...state,
        DID_NUMBER: response?.data?.data?.DIDNumberList?.[0],
      }));
      if (!response?.data?.data?.DIDNumberList?.[0]?.DID_NUMBER) {
        setHandleError((handleError) => "there is no data");
      }
    } catch (err) {
      setHandleError((handleError) => err.message);
      console.error("Failed to fetch DID number", err);
    } finally {
      setState((state) => ({ ...state, LOADER: false }));
    }
  };

  useEffect(() => {
    if (areBIDAndInsIdPresent()) {
      setState((state) => ({ ...state, LOADER: true }));
      fetchData();
    }
  }, []);

  // Yup validation schema
  const validationSchema = Yup.object().shape({
    LANGUAGE: Yup.string().required("Please select a language."),
    ADMISSION_COUNSELLOR_MOBILE: Yup.string()
      .required("Mobile number is required")
      .matches(/^\d+$/, "Mobile number must contain only digits"),
    COUNTRY_CODE: Yup.string().required("Country code is Required"),
  });

  console.log("state?.DID_NUMBER?.DID_NUMBER", state?.DID_NUMBER?.DID_NUMBER);

  return !!handleError ? (
    <div
      className={`flex flex-col justify-center items-center text-center w-full mt-[15vh] px-10 gap-2`}
    >
      <Lottie animationData={SateliteAnimation} className="w-[8vh]" />
      <h2 className="text-[3.5vh] font-manropeEB flex items-baseline gap-2">
        Fetching interrupted, but we’re on it
      </h2>
      <p className="text-[2vh] text-gray-500">
        Looks like something went off track while fetching your school’s IVR
        number. It <br />
        could be a momentary glitch.
      </p>
      <div className="flex justify-center items-center gap-4">
        <button
          type="button"
          className="px-[3vh] py-[2vh] text-[2vh] text-[white] font-manropeM bg-[#5E4DE0] rounded-xl"
          onClick={fetchData}
        >
          Retry
        </button>
        <button
          type="button"
          className="px-[3vh] py-[2vh] text-[2vh] font-manropeM bg-gray-200 rounded-xl shadow"
        >
          Contact Us
        </button>
      </div>
    </div>
  ) : !finalNumber ? (
    <div
      className={`flex flex-col justify-center items-center text-center w-full mt-[15vh] px-10 gap-2 ${
        !!state?.DID_NUMBER?.DID_NUMBER ? "animate-scaleOut" : "animate-scaleIn"
      }`}
    >
      <h2 className="text-[3.5vh] font-manropeEB flex items-baseline gap-2">
        Setting up your IVR line...
      </h2>
      <p className="text-[2vh] text-gray-500">
        We're securing a dedicated phone number for your school’s IVR system.
        This line will help parents <br /> and inquiries reach the right
        information instantly. hhhh
      </p>
      <div className="flex justify-center items-center gap-[0.5rem] p-1 bg-[#5a47ea] rounded-xl my-4">
        {Array.from({ length: 10 }).map((_, i) => (
          <SlotDigit
            key={i}
            index={i}
            showZero={
              areBIDAndInsIdPresent() ? !areBIDAndInsIdPresent() : showZero
            }
            value={
              state?.DID_NUMBER?.DID_NUMBER
                ? state?.DID_NUMBER?.DID_NUMBER[i]
                : "0"
            }
          />
        ))}
      </div>
      {!state?.LOADER ? (
        <p className="text-[2vh] text-[black] front-manropeSB">
          Done! Your IVR number is activated.
        </p>
      ) : (
        <Carousel
          className="h-[3vh]"
          autoPlay
          showArrows={false}
          infiniteLoop
          axis="vertical"
          showIndicators={false}
          showStatus={false}
          showThumbs={false}
        >
          {loadingMessages?.map((item, index) => (
            <p
              key={"asdasdasdasd" + index}
              className="text-[2vh] text-[black] front-manropeSB"
            >
              {item}
            </p>
          ))}
        </Carousel>
      )}
    </div>
  ) : (
    <div className="flex flex-col justify-center items-center text-center w-full px-10 gap-8">
      <h2 className="text-[3.5vh] font-manropeEB flex items-baseline gap-2">
        Your IVR Number Is Ready!
      </h2>
      <div className="w-[99%] overflow-hidden bg-demoBGPrimary">
        <div className="relative flex justify-center items-center w-full gap-6 h-[10vh]">
          <div className="absolute inset-0 flex items-center justify-center z-10 p-4">
            <div className="bg-[white]">
              <div className="bg-ivrNumber flex justify-center items-center gap-4 py-4 px-12">
                <div className="bg-[white] rounded-full">
                  <Lottie animationData={HrAnimation} className="w-[8vh]" />
                </div>
                <span className="text-[3.5vh] text-[white] font-manropeSB tracking-widest">
                  {state?.DID_NUMBER?.DID_NUMBER}
                </span>
              </div>
            </div>
          </div>
          <Suspense fallback={<div>Loading feed...</div>}>
            <Marquee speed={50} direction="left">
              {LIST?.map((item, index) => (
                <div
                  key={"asdbaskjdbasjdasd" + index}
                  className="mx-6 w-fit grid grid-cols-12 items-center gap-2"
                >
                  <div className="col-span-4">{item?.image}</div>
                  <div className="col-span-8">{item?.title}</div>
                </div>
              ))}
            </Marquee>
          </Suspense>
        </div>
      </div>
      <div className="flex flex-col items-center gap-2 w-full">
        <h2 className="text-[3.5vh] font-manropeEB">
          Choose Your School’s IVR Languages for Parent Communication
        </h2>
        <p className="text-[2vh] text-[black] front-manropeSB text-center">
          Select from multiple languages to ensure parents receive updates in
          their preferred tongue, making <br />
          school announcements accessible to all.
        </p>
        <Formik
          initialValues={loadInitialData()}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            try {
              setLoader(true);
              sessionStorage.setItem("autoConnectHub", JSON.stringify(values));
              const payload = {
                ...values,
                DID_NUMBER_ID: state?.DID_NUMBER?.DID_NUMBER_ID,
                INSTITUTE_ID: instData?.INSTITUTE_ID,
                BRANCH_ID: instData?.BRANCH_ID,
                DBN: instData?.DATABASE_NAME,
              };
              const response = await axios.post(
                `${API_CONSTANT_ONBOARDING}/master/branchDid/select`,
                payload,
                {
                  headers: {
                    database: instData?.DATABASE_NAME,
                    "branch-id": instData?.BRANCH_ID,
                    "institute-id": instData?.INSTITUTE_ID,
                  },
                }
              );
              if ([200, 201].includes(+response?.data?.code)) {
                handleNavigate(false, "/onboarding/autoFeeHub");
              } else {
                showGlobalModal(response?.data?.message, "warning");
              }
            } catch (err) {
              showGlobalModal(err.message, "error");
            } finally {
              setLoader(false);
            }
          }}
        >
          {({ handleSubmit, values, resetForm, errors }) => (
            <Form onSubmit={handleSubmit} className="w-full">
              <div className="flex flex-col justify-between w-full h-full">
                <div className="flex flex-col items-center gap-y-[4vh]">
                  <div className="w-[25%] space-y-[0.5vh]">
                    <p className="text-[2.4vh] font-manropeSB">
                      Select languages <span className="text-[red]">*</span>
                    </p>
                    <div className="flex flex-col gap-2 bg-[white] drop-shadow shadow-lg border-0 rounded-xl p-[1vh] text-[2.8vh]">
                      <Field
                        as="select"
                        name="LANGUAGE"
                        className="text-center w-full rounded-lg text-[2.5vh] text-[#484848] py-1 px-2 focus:outline-none focus:ring-0 focus:border-smd_golden-light"
                      >
                        <option value="" disabled>
                          Select language
                        </option>
                        {globalData?.IvrLanguages?.map((item) => (
                          <option key={item?.label} value={item?.value}>
                            {item?.label}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="LANGUAGE"
                        component="div"
                        className="text-red-500 text-[1.8vh] px-1"
                      />
                    </div>
                  </div>
                  <div className="w-[25%] space-y-[0.5vh]">
                    <p className="text-[2.4vh] font-manropeSB">
                      Admission Counselor Mobile Number{" "}
                      <span className="text-[red]">*</span>
                    </p>
                    <Input
                      //   disable={disableForm}
                      //   label="Mobile Number"
                      name={`ADMISSION_COUNSELLOR_MOBILE`}
                      type="text"
                      placeHolder="Enter Admission Counselor Mobile Number"
                      isMobile
                      countryCodeName={`COUNTRY_CODE`}
                      required
                    />
                  </div>
                </div>
                <div className="flex justify-end my-2">
                  {loader ? (
                    <Img
                      src={"/images/loader.gif"}
                      className="w-10 h-10"
                      alt="Loading"
                    />
                  ) : (
                    <ResetAndSubmit
                      submitLabel="Proceed"
                      submitToolTip={
                        !!Object.keys(errors).length &&
                        "At least one language is required for the next step."
                      }
                      isError={!!Object.keys(errors).length}
                      resetForm={() => {
                        resetForm();
                        resetFormData();
                      }}
                    />
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );

  // <div className="col-span-5 flex justify-center">
  //     <div className="w-full font-manrope text-[white] bg-[#62AA48] rounded-3xl flex flex-col justify-between items-center gap-2 text-center p-2">
  //         <Img src="/images/Onboarding/AutoConnect.svg" className="h-[35vh]" />
  //         <p className="font-manropeB text-[3.5vh]">Your School dedicated number</p>
  //         <p className="font-manropeM text-[2vh]">
  //             Parents can dial the dedicated IVR number to get the latest <br />
  //             updates about the school, student progress, and important <br />
  //             announcements.
  //         </p>

  //         <div className="relative h-[18vh] w-fit">
  //             <Img src="/images/Onboarding/GreenBox.svg" className="h-full w-auto" />
  //             <p className="absolute inset-0 flex items-center justify-center font-manropeEB text-[5vh] text-white">
  //                 {state?.LOADER ? (
  //                     <div className="bg-[white] rounded-full p-1 mt-2">
  //                         <Img src="/images/loader.gif" className="h-10" />
  //                     </div>
  //                 ) : (
  //                     state?.DID_NUMBER?.DID_NUMBER
  //                 )}
  //             </p>
  //         </div>
  //     </div>
  // </div>

  // <div className="col-span-7 space-y-3 h-full">
  //     <h2 className="text-[2.5vh] font-semibold tracking-wide">
  //         Choose Your School’s IVR Languages for Parent Communication
  //     </h2>
  //     <p className="text-[2vh] text-gray-500">
  //         Select from multiple languages to ensure parents receive updates in their preferred tongue, making school announcements accessible to all.
  //     </p>

  //     <Formik
  //         initialValues={loadInitialData()}
  //         validationSchema={validationSchema}
  //         onSubmit={async (values) => {
  //             try {
  //                 setLoader(true);
  //                 sessionStorage.setItem("autoConnectHub", JSON.stringify(values));
  //                 const payload = {
  //                     ...values,
  //                     DID_NUMBER_ID: state?.DID_NUMBER?.DID_NUMBER_ID,
  //                     INSTITUTE_ID: instData?.INSTITUTE_ID,
  //                     BRANCH_ID: instData?.BRANCH_ID,
  //                     DBN: instData?.DATABASE_NAME
  //                 };
  //                 const response = await axios.post(`${DEV_BASE}/data/branchDid/select`, payload, {
  //                     headers: {
  //                         database: instData?.DATABASE_NAME,
  //                         "branch-id": instData?.BRANCH_ID,
  //                         "institute-id": instData?.INSTITUTE_ID,
  //                     }
  //                 });
  //                 if ([200, 201].includes(+response?.data?.code)) {
  //                     handleNavigate(false, "/onboarding/autoFeeHub");
  //                 } else {
  //                     showGlobalModal(response?.data?.message, "warning")
  //                 }
  //             } catch (err) {
  //                 showGlobalModal(err.message, "error");
  //             } finally {
  //                 setLoader(false);
  //             }
  //         }}
  //     >
  //         {({ handleSubmit, values, resetForm, errors }) => (
  //             <Form onSubmit={handleSubmit} className="h-[82%]">
  //                 <div className="flex flex-col justify-between h-full">
  //                     <div className="space-y-[4vh]">
  //                         <div className="space-y-[1vh]">
  //                             <p className="text-[2.4vh] font-manropeSB">Select Language <span className="text-[red]">*</span></p>
  //                             <div className="flex flex-col gap-2 bg-[white] drop-shadow shadow-lg border-0 rounded-xl p-[1vh] text-[2.8vh]">
  //                                 <Field
  //                                     as="select"
  //                                     name="LANGUAGE"
  //                                     className="text-center w-full rounded-lg text-[2.5vh] text-[#484848] py-1 px-2 focus:outline-none focus:ring-0 focus:border-smd_golden-light"
  //                                 >
  //                                     <option value="" disabled>
  //                                         Select language
  //                                     </option>
  //                                     {globalData?.IvrLanguages?.map((item) => (
  //                                         <option key={item?.label} value={item?.value}>
  //                                             {item?.label}
  //                                         </option>
  //                                     ))}
  //                                 </Field>
  //                                 <ErrorMessage
  //                                     name="LANGUAGE"
  //                                     component="div"
  //                                     className="text-red-500 text-[1.8vh] px-1"
  //                                 />
  //                             </div>
  //                         </div>
  //                         <div className="space-y-[1vh]">
  //                             <p className="text-[2.4vh] font-manropeSB">Admission Counselor Mobile Number <span className="text-[red]">*</span></p>
  //                             <Input
  //                                 // disable={disableForm}
  //                                 // label="Mobile Number"
  //                                 name={`ADMISSION_COUNSELLOR_MOBILE`}
  //                                 type="text"
  //                                 placeHolder="Enter Admission Counselor Mobile Number"
  //                                 isMobile
  //                                 countryCodeName={`COUNTRY_CODE`}
  //                                 required
  //                             />
  //                         </div>
  //                     </div>
  //                     <div className="flex justify-end my-2">
  //                         {loader ? (
  //                             <Img
  //                                 src={"/images/loader.gif"}
  //                                 className="w-10 h-10"
  //                                 alt="Loading"
  //                             />
  //                         ) : (
  //                             <ResetAndSubmit
  //                                 submitLabel="Proceed"
  //                                 submitToolTip={!!Object.keys(errors).length && "At least one language is required for the next step."}
  //                                 isError={!!Object.keys(errors).length}
  //                                 resetForm={() => {
  //                                     resetForm();
  //                                     resetFormData();
  //                                 }}
  //                             />
  //                         )}
  //                     </div>
  //                 </div>
  //             </Form>
  //         )}
  //     </Formik>
  // </div>
};

export default AutoConnectHub;
